import QueryParamsOperator from './QueryParamsOperator'

export default QueryParamsOperator
